/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 23/11/22
 */

import { FormType } from '@/components/contexts/FormsContext/FormsProvider';
import { useWorkplan } from '@/components/contexts/WorkplanContext/useWorkplan';
import FormSchemas from '@/components/FormSchemas/FormSchemas';
import { Workplan } from '@/wpt-lib/interfaces/Workplan';
import { JsonSchema, UISchemaElement } from '@jsonforms/core';
import React, { ReactNode } from 'react';

const getWorkplanFormIdForType = (type: FormType, workplan: Workplan) => {
    switch (type) {
        case FormType.ACTIVITY:
            return workplan.activityFormTemplateId;
        case FormType.PERSONAL_GOAL:
            return workplan.goalFormTemplateId;
        case FormType.LEAVE:
            return workplan.leaveFormTemplateId;
        case FormType.HEALTH_AND_SAFETY_TRAINING:
            return workplan.trainingFormTemplateId;
        case FormType.CONSIDERATION:
            return workplan.considerationFormTemplateId;
        case FormType.BEHAVIOURAL:
            return workplan.behaviouralFormTemplateId;
    }
};

const WorkplanFormSchemas = ({
    type,
    render,
}: {
    type: FormType;
    render: (schemas: { schema: JsonSchema; uischema: UISchemaElement }) => ReactNode;
}) => {
    const { workplan } = useWorkplan();
    return <FormSchemas id={workplan ? getWorkplanFormIdForType(type, workplan) : workplan} render={render} />;
};

export default WorkplanFormSchemas;
